import './field-settings.scss';
import { mapGetters, mapActions } from 'vuex';

import SwitchOption from './FieldOptions/SwitchOption';
import LocalFieldMixin from './LocalFieldMixin';
import ExpansionPanel from '@/components/BlockEditorWidget/FieldSettings/WidgetSettings/ExpansionPanel';
import CombinedInputFieldDataMenu from '@/components/DataInput/CombinedInputFieldDataMenu';
import { getAction } from '@/store/modules/actions/getters';
import { editNode } from '@/store/modules/selectedNode/getters';
import { mapGettersShorthand } from '@/store/utils/mappers';
export default {
	//FieldSettingsMixin
	components: {
		SwitchOption,
		ExpansionPanel,
		CombinedInputFieldDataMenu,
	},
	mixins: [LocalFieldMixin],
	props: {
		previousSteps: { type: Object },
		replaceInsertDataStringDict: { type: Object, default: () => {} },
		configurationsMappingBlocksUUIDs: { type: Array, default: () => [] },
	},
	computed: {
		...mapGettersShorthand({ editNode, getAction }),
		...mapGetters(['selectedNode/editNode']),
		...mapGetters('widgetEditor', ['editField']),
		action() {
			return this.getAction(this.editNode?.action);
		},
	},
	methods: {
		...mapActions('widgetEditor', ['updateWidgetFieldEdit']),
	},
	data() {
		return {
			panel: 0,
		};
	},
};

export const getComputedMetadataOption = (prop, attr = undefined) => ({
	get() {
		const opt = this.localField?.metadata.options[prop];
		return attr ? opt[attr] : opt;
	},
	set(value) {
		const opt = `metadata.options.${prop}` + (attr ? `.${attr}` : '');
		this.setLocalFieldKey(opt, value);
	},
});
